import React from 'react'
// hooks
import { formatDateValue, useDatePicker } from 'hooks/useDatePicker'
// components
import { DesktopDateTimePicker, DesktopDateTimePickerProps } from '@mui/x-date-pickers/DesktopDateTimePicker'

export interface CustomDateTimePickerProps extends Omit<DesktopDateTimePickerProps<any>, 'onChange' | 'label'> {
  error?: boolean
  label?: string
  onChange: (value: string) => void
  required?: boolean
  dateFormat?: string
}

const DateTimePickerComponent: React.FC<CustomDateTimePickerProps> = ({
  value,
  label,
  error,
  minDate,
  maxDate,
  required,
  onChange,
  dateFormat,
  ...rest
}) => {
  const { props } = useDatePicker({
    value,
    label,
    error,
    required,
    onChange
  })

  return (
    <DesktopDateTimePicker
      {...rest}
      {...props}
      ampm={dateFormat?.toLowerCase().includes('a') || false}
      minDate={formatDateValue(minDate)}
      maxDate={formatDateValue(maxDate)}
      format={dateFormat || 'DD MM YYYY HH:mm'}
    />
  )
}

export default DateTimePickerComponent
